export const removeSuccessToast = {
  title:
    '$t(tracker:displayKind, {"context": "{{context}}" }) has been successfully deleted.',
};
